module.exports = __webpack_public_path__ + "assets/icons/ic_zoom_in-2743.svg";